import icon from "../images/icons/best-man.png";

const obj = {
  title: "Best Man",
  to: "/ai/wedding/bestman",
  api: "/ai/wedding",
  getApi: "/ai/wedding/bestMan",
  historyType: "bestMan",
  toolType: "speech",
  buttonTitle1: "Draft my speech",
  buttonTitle2: "Refine my speech",
  textTitle: "Speech",
  output: {
    title: "Speech Preview",
    Icon: false,
    color: "blue",
  },
  icon: icon,

  prompts: [
    {
      title: "Step 1: Provide Key Information",
      id: "information",
      desc: "Answer questions about the couple to get a custom-written draft toast. Share fun stories and specific details for the best results.",
      // n: 1,
      instruction: `<!-- <h1>Craft a memorable toast in a few simple steps:</h1> --> 
      <li>Get your draft: Answer questions.</li> 
      <li>Make it yours: Give feedback or tap speech to edit.</li> 
      <li>Ready to share: Export for the big day.</li>`,
      prompts: [
        {
          title: "Best Man's name",
          attr: "name",
          value: "",
          //placeholder: "My name is...",
          //label: "Examples: Accountant, Developer, Dentist, Receptionist",
          type: "text",
          maxLength: 40,
          // max: 100,
          //min: 2,
          required: true,
          error: "",
          example: "Chris",
        },
        {
          title: "Groom's name",
          attr: "groomsName",
          value: "",
          //placeholder: "The Groom’s name is...",
          //label: "Examples: Accountant, Developer, Dentist, Receptionist",
          type: "text",
          maxLength: 40,
          // max: 100,
          //min: 2,
          required: true,
          error: "",
          example: "Dave",
        },
        {
          title: "Groom's partner",
          attr: "bridesName",
          value: "",
          //placeholder: "His partner’s name is...",
          //label: "Examples: Accountant, Developer, Dentist, Receptionist",
          type: "text",
          maxLength: 40,
          // max: 100,
          //min: 2,
          required: true,
          error: "",
          example: "Laura",
        },
        {
          title: "What tone are you aiming for in your speech? (E.g. Heartfelt, funny, formal, or a blend)",
          attr: "tone",
          value: "",
          //placeholder: "I would like to speech to be...",
          //label:
            //"E.g. Heartfelt, Funny, Formal, Balanced Mix.",
          type: "text",
          maxLength: 100,
          // max: 100,
          //min: 2,
          required: true,
          error: "",
          example:
            "My preferred tone for the speech is lighthearted and humorous,",
        },
        {
          title: "Three words that describe the Groom",
          attr: "groomWords",
          value: "",
          //placeholder: "The Groom is...",
          // label:
          //"Examples: beautiful, loving, loyal",
          type: "text",
          maxLength: 100,
          // max: 100,
          //min: 2,
          required: true,
          error: "",
          example: "The Groom is loyal, intelligent, hard-working.",
        },
        {
          title: "Three words that describe his partner",
          attr: "brideWords",
          value: "",
          //placeholder: "The Groom's partner is...",
          // label:
          //"Examples: beautiful, loving, loyal",
          type: "text",
          maxLength: 100,
          // max: 100,
          //min: 2,
          required: true,
          error: "",
          example: "The Groom's partner is beautiful, smart, loyal.",
        },
        //{
          //title:
            //"Tell us how you met the Groom and share a favourite memory.",
          //attr: "friendshipDuration",
          //value: "",
          //placeholder: "I met the Groom...",
          //label: "Examples: School, college, sport, housemates, work. ",
          //type: "textarea",
          //maxLength: 300,
          // max: 100,
          //min: 2,
          //required: true,
          //error: "",
          //example:
            //"I met the groom at university back in 1999. Dave and I hit it off right away, with both of us studying finance, and having a shared passion for beer and pretty much all sports.",
        //},
        {
          title: "Tell us how you met the Groom and share a favourite memory.",
          attr: "groomMemories",
          value: "",
          //placeholder: "My favorite memories with the Groom...",
          //label: "Examples: School, uni, sport, housemates, work. ",
          type: "textarea",
          maxLength: 500,
          // max: 100,
          //min: 30,
          required: false,
          error: "",
          example:
            "I hit it off right away with the groom. We both studied business at college and loved football",
        },
        {
          title:
            "What are the Groom's best qualities? Can you think of a time they really shone through?",
          attr: "teenager",
          value: "",
          //placeholder: "The Groom...",
          //label: "Examples: School, uni, sport, housemates, work. ",
          type: "textarea",
          maxLength: 500,
          // max: 100,
          //min: 30,
          required: false,
          error: "",
          example:
            "He lacked style as a teenager, but now he's a real fashionista",
        },
        {
          title: "What's a hilarious moment that captures the Groom's personality?",
          attr: "funnyGroom",
          value: "",
          //placeholder: "The Groom...",
          //label: "Examples: School, uni, sport, housemates, work. ",
          type: "textarea",
          maxLength: 500,
          // max: 100,
          //min: 30,
          required: false,
          error: "",
          example:
            "He has no sense of rhythm and can't dance to save himeself - but that never stopped him trying",
        },
        //{
          //title:
            //"Groom's funny hobbies or passions?",
          //attr: "hobbies",
          //value: "",
          //placeholder: "The Groom...",
          // label: `Examples: The groom collects stamps" - we don’t need it`,
          //type: "textarea",
          //maxLength: 300,
          // max: 100,
          //min: 30,
          //required: false,
          //error: "",
          //example: "The groom collects stamps",
        //},
        {
          title:
            "Why are the Groom and his partner such a great match? What's a moment that showed you this?",
          attr: "coupleMeet",
          value: "",
          //placeholder: "The Groom met his partner...",
          //label: "Examples: Lost his passport on a night out in Prague",
          type: "textarea",
          maxLength: 500,
          // max: 100,
          //min: 30,
          required: false,
          error: "",
          example:
            "The groom met his partner Laura at a party in 2012. Laura has a great sense of humour and is always making the groom laugh. Laura has had a positive impact on the Groom by encouraging him to be more outgoing and sociable.",
        },
        {
          title:
            "Describe his partner's best qualities, and how do they bring out the best in him?",
          attr: "brideImpression",
          value: "",
          //placeholder: "My first impressions of...",
          //label: "Examples: Lost his passport on a night out in Prague",
          type: "textarea",
          maxLength: 500,
          // max: 100,
          //min: 30,
          required: false,
          error: "",
          example:
            "My first impressions of Laura were that she is really fun and outgoing. The life of the party. As I got to know her over time, it became really clear that she's hard-working, caring and really supportive. A lovely person all-round.",
        },
        //{
          //title: "Share a funny or heartwarming detail about the proposal.",
          //attr: "proposal",
          //value: "",
          //placeholder: "The proposal...",
          //label: "Examples: Lost his passport on a night out in Prague",
          //type: "textarea",
          //maxLength: 300,
          // max: 100,
          //min: 30,
          //required: false,
          //error: "",
          //example:
            //"The groom proposed on holiday in Capri. He had planned to propose on the beach, but the weather was so bad that they had to move the proposal to the hotel room. The groom was so nervous that he dropped the ring in the bath. Luckily, his partner was able to fish it out.",
        //},
        //{
          //title: "What makes the couple unique?",
          //attr: "unique",
          //value: "",
          //placeholder: "The couple...",
          //label: "Examples: Lost his passport on a night out in Prague",
          //type: "textarea",
          //maxLength: 300,
          // max: 100,
          //min: 30,
          //required: true,
          //error: "",
          //example:
            //"They make a really great team. Their personalities are very different, but they complement each other really well. They are both very caring and thoughtful people.",
        //},
        {
          title:
            "Describe a time when the couple faced something together, showcasing their love, strength, or connection.",
          attr: "coupleAnecdotes",
          value: "",
          //placeholder: "A story that springs to mind is...",
          //label: "Examples: Lost his passport on a night out in Prague",
          type: "textarea",
          maxLength: 500,
          // max: 100,
          //min: 30,
          required: false,
          error: "",
          example:
            "They are a really intelligent couple, but somehow often make silly blunders. They once tried making homemade pizza together but accidentally used baking soda instead of flour. The result was a hilarious, inedible mess!",
        },
        //{
          //title: "The couple's dreams for the future?",
          //attr: "coupleGoals",
          //value: "",
          //placeholder: "The couple...",
          //label: "Examples: Start a family, live overseas etc.",
          //type: "textarea",
          //maxLength: 300,
          // max: 100,
          //min: 30,
          //required: false,
          //error: "",
          //example:
            //"They want to start a family and have a couple of kids. They would make wonderful parents.",
        //},
        {
          title:
            "What are your hopes and dreams for the couple's life together?",
          attr: "coupleMilestones",
          value: "",
          //placeholder: "A notable achievement that comes to mind is...",
          //label: "Example: Had a child or children together.",
          type: "textarea",
          maxLength: 500,
          // max: 100,
          //min: 30,
          required: false,
          error: "",
          example:
            "They lived abroad for five years and have travelled to many different countries together. They have also overcome some difficult challenges together, such as the groom's father passing away.",
        },
        {
          title:
            "Is there anything else you would like to include in your speech?",
          attr: "wisdom",
          value: "",
          //placeholder: "I would like to...",
          //label: "Examples: Add a joke, a poem, or an inspirational quote etc.",
          type: "textarea",
          maxLength: 500,
          // max: 100,
          //min: 30,
          required: false,
          error: "",
          example:
            "I hit it off right away with the groom. We both studied business at college and loved football",
        },
      ],
      example: {
        output:
          "Good evening everyone, and welcome to Dave and Laura's wedding day. For those of you who don't know me, my name is Chris, and I am the best man. It is an honour to be standing here today, not just as Dave's best friend, but also as a witness to this amazing union between two wonderful people. \n\nFirst of all, I want to welcome all of our guests, especially those of you who have travelled from Ireland for the occasion, including Dave�s nana and granddad. It just goes to show you how far people will go for a free drink. And I promise you, there will be plenty of that tonight! \n\nI also want to take a moment to acknowledge the bridesmaids and thank them for their part in this day. Their hard work and dedication to making this day special for Laura and Dave is greatly appreciated. \n\nNow, before I get into my speech, I have to acknowledge how stunning the bride looks. Laura, you are truly a vision in white. I think everyone here would agree with me that Dave is definitely punching above his weight. \n\nDave and I met at university back in 1999, and I have to say, it was a different time. I'm Blue (Da Ba De) had dancefloors pumpin, Hit Me Baby One More Time was on top of the charts, and Ricky Martin was Livin La Vida Loca. But without a doubt, the biggest abomination of the year was Dave's haircut. He had a curly mop and a terrible rats tail. But I must admit, he's tidied himself up nicely today. Though, as the saying goes, 'You can't polish a turd, but you can roll it in glitter. \n\nDave and I hit it off right away, with both of us studying finance, and having a shared passion for beer and pretty much all sports. Dave is a diehard West Ham United supporter and has been through many, many lean years. He used to get up in the early hours of the morning to listen to the Hammers� games on the internet back in the dial-up days! Despite his calm demeanour, he�d get so fired up when they played and you'd hear him screaming in the middle of the night if they scored or throwing his computer mouse at the wall if they conceded. \n\nHe also played quite a bit of soccer and was a pretty handy player. But one thing immediately springs to mind when I think about Dave and soccer � and that�s �The goal�. As many of you will know, the legendary bicycle kick he scored in under-12s is still his claim to fame. In uni, he�d bring the goal up at any opportunity and chew the ear off anyone who was unfortunate enough to listen. As far as I know, no one here has actually seen the goal and no one can remember it (and I�ve checked with his mum and dad). Quick show of hands � who here thinks it was really as good as he says? \n\nDave has always been an amazing mate to his friends and a great son and brother. He is loyal to a fault, generous beyond measure and always put others first. Though don't worry, this speech won't be all sunshine and rainbows. Dave has a terrible secret - yes, it's true. He used to collect Tamagotchi pets (though he�ll try to tell you that belonged to his sister Ruth). \n\nSome of my favourite memories with Dave include going to the beach daily during summer holidays, doing a year abroad in Europe and camping trips in the bush with the uni gang. We had some epic games of spotlight out there - Dave was a ghost when it came to spotlight. He took it way too seriously � everyone else would hide behind a tree and Dave would be covering himself in muck and leaves and crawling to avoid detection. Despite a bit of white line fever, Dave is super relaxed and can fall asleep anywhere. And while that�s a handy trait when you�re travelling, it has come back to bite him more than once. For example, Dave would occasionally nod off on the train and miss his stop, only to be woken at the end of the line. Though for me, the time he fell back asleep and passed his stop again after missing it the first time takes the cake. \n\nShifting gears slightly, it was always clear to me that Dave was destined to be a great husband and one day an amazing father. And he met the perfect partner in Laura. Laura lights up every room she enters with her bright and bubbly personality and lovely demeanour. \n\nDespite being quite different in terms of their personalities, their values perfectly align and they really complement one another. They're a perfect fit. Laura brings out the best in Dave and I have noticed how he has really stepped up his game, matured and grown as a person since meeting Laura. \n\nI think the following quote perfectly captures the essence of Dave and Laura's relationship. Love is not only something you feel, it is something you do. This is abundantly clear when you spend time with Dave and Laura. They treat each other with great respect and support and encourage one another. And when it comes to the airport, both Dave and Laura will park their car and wait at the arrivals gate to greet each other when one is returning from a work trip.  That�s love. \n\nSo without further ado, let's raise a final toast to the newlyweds. Dave and Laura, may your love continue to grow stronger with each passing day, may you always find happiness in one another, and may you never stop making each other laugh. \n\nCongratulations Dave and Laura, and cheers to a lifetime of love and happiness.",
        color: "blue",
      },
    },
    {
      title: "Step 2: Refine Speech",
      id: "refine",
      desc: "Tweak your speech for the perfect fit. Adjust the tone, add stories, or suggest any edits you want. Your speech will update instantly.",
      instruction: "Number of automated revisions left:",
      prompts: [
        {
          title:
            "What changes would you like?",
          attr: "feedbackdescription",
          value: "",
          //placeholder: "Please update the...",
          // label: "Examples: Accountant, Developer, Dentist, Receptionist",
          type: "textarea",
          minRows: 5,
          maxLength: 800,
          required: true,
          error: "",
        },
      ],
    },
  ],
};

export default obj;
